__webpack_require__.p = "/Food-Delivery-Application/";